export const stateRates = [
  { state: 'AK', rate: '$52' },
  { state: 'AL', rate: '$42' },
  { state: 'AR', rate: '$48' },
  { state: 'AZ', rate: '$45' },
  { state: 'CA', rate: '$58' },
  { state: 'CO', rate: '$42' },
  { state: 'CT', rate: '$63' },
  { state: 'DC', rate: '$64' },
  { state: 'DE', rate: '$45' },
  { state: 'FL', rate: '$44' },
  { state: 'GA', rate: '$52' },
  { state: 'HI', rate: '$52' },
  { state: 'IA', rate: '$50' },
  { state: 'ID', rate: '$52' },
  { state: 'IL', rate: '$49' },
  { state: 'IN', rate: '$47' },
  { state: 'KS', rate: '$47' },
  { state: 'KY', rate: '$42' },
  { state: 'LA', rate: '$44' },
  { state: 'MA', rate: '$59' },
  { state: 'MD', rate: '$53' },
  { state: 'ME', rate: '$54' },
  { state: 'MI', rate: '$47' },
  { state: 'MN', rate: '$54' },
  { state: 'MO', rate: '$50' },
  { state: 'MS', rate: '$36' },
  { state: 'MT', rate: '$55' },
  { state: 'NC', rate: '$44' },
  { state: 'ND', rate: '$52' },
  { state: 'NE', rate: '$50' },
  { state: 'NH', rate: '$53' },
  { state: 'NJ', rate: '$51' },
  { state: 'NM', rate: '$52' },
  { state: 'NV', rate: '$46' },
  { state: 'NY', rate: '$62' },
  { state: 'OH', rate: '$50' },
  { state: 'OK', rate: '$38' },
  { state: 'OR', rate: '$46' },
  { state: 'PA', rate: '$53' },
  { state: 'RI', rate: '$60' },
  { state: 'SC', rate: '$52' },
  { state: 'SD', rate: '$60' },
  { state: 'TN', rate: '$43' },
  { state: 'TX', rate: '$42' },
  { state: 'UT', rate: '$44' },
  { state: 'VA', rate: '$50' },
  { state: 'VT', rate: '$49' },
  { state: 'WA', rate: '$50' },
  { state: 'WI', rate: '$49' },
  { state: 'WV', rate: '$45' },
  { state: 'WY', rate: '$52' },
];
